import styled, { css } from 'styled-components'
import { layout, LayoutProps, margin, MarginProps } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

type Variants = {
  danger?: boolean
}

type Sizes = {
  compact?: boolean
}

export type WrapperProps = MarginProps & LayoutProps & Variants & Sizes

const shouldForwardProp = (prop: string) =>
  !['danger', 'compact'].includes(prop)

const wrapperDangerCss = ({ danger }: Variants) =>
  danger &&
  css`
    color: ${themeGet('colors.error.main')};
  `

export const Wrapper = styled.div.withConfig({
  shouldForwardProp,
})<WrapperProps>`
  display: flex;
  flex-direction: column;
  color: ${themeGet('colors.text.secondary')};

  ${margin};
  ${layout};

  ${wrapperDangerCss}
`

const containerDangerCss = ({ danger }: Variants) =>
  danger &&
  css`
    border-bottom: 1px solid ${themeGet('colors.error.main')};
  `

const containerCompactCss = ({ compact }: Sizes) =>
  compact &&
  css`
    min-height: 24px;
  `

export const Container = styled.div.withConfig({ shouldForwardProp })<
  Variants & Sizes
>`
  display: flex;
  align-items: center;
  min-height: 36px;
  position: relative;
  border-bottom: 1px solid ${themeGet('colors.line.primary')};

  ${containerDangerCss}
  ${containerCompactCss}
`

export const StyledInput = styled.input`
  width: 100%;
  color: ${themeGet('colors.text.primary')};
  border: none;
  outline: none;
  font-size: 16px;
  font-weight: ${themeGet('fontWeights.0')};
  letter-spacing: -0.25px;
  margin: 0;

  &::placeholder {
    font-size: 16px;
    font-weight: ${themeGet('fontWeights.0')};
    letter-spacing: -0.25px;
    color: ${themeGet('colors.text.primary')};
  }
`
